import { State } from "./state";
import { MutationTree } from "vuex";
import { IS_LOADING, SET_ERROR, SET_SUCCESS, SET_DATA_ITEM, SET_DATA_LIST } from "@/store/Crud/functions/mutations";
import {
  SET_ADDITIONAL_BOOK_A,
  SET_ADDITIONAL_BOOK_B,
  SET_BASE_BOOK,
  SET_BASE_PAGE,
  SET_BOOK_A_PAGE,
  SET_BOOK_B_PAGE,
  SET_PAGE_LOADING,
} from "@/store/WikiDriveBuzz/types";

export default <MutationTree<State>>{
  IS_LOADING,
  SET_ERROR,
  SET_SUCCESS,
  SET_DATA_ITEM,
  SET_DATA_LIST,

  [SET_BASE_BOOK](state: State, book: any) {
    state.baseKnowledgeBook = book;
  },

  [SET_ADDITIONAL_BOOK_A](state: State, book: any) {
    state.additionalKnowledgeBookA = book;
  },

  [SET_ADDITIONAL_BOOK_B](state: State, book: any) {
    state.additionalKnowledgeBookB = book;
  },

  [SET_BASE_PAGE](state: State, htmlPage: string) {
    state.baseHtmlPage = htmlPage;
  },

  [SET_BOOK_A_PAGE](state: State, htmlPage: string) {
    state.additionalBookAHtmlPage = htmlPage;
  },

  [SET_BOOK_B_PAGE](state: State, htmlPage: string) {
    state.additionalBookBHtmlPage = htmlPage;
  },

  [SET_PAGE_LOADING](state: State, loading: boolean) {
    state.pageLoading = loading;
  },
};
